export default {
	computed: {
		customerName() {
			let vm = this

			if (this.$store.serviceContract) {
				if ("Customer" in this.$store.serviceContract && this.$store.serviceContract.Customer)
					return this.$store.serviceContract.Customer.name
				if ("Service" in this.$store.serviceContract && this.$store.serviceContract.Service.length > 0) {
					if ("Customer" in this.$store.serviceContract.Service[0] && this.$store.serviceContract.Service[0].Customer)
					return this.$store.serviceContract.Service[0].Customer.name
				}

				if (!this.$store.serviceContract.customer_id)
					return ""

				let selectedCustomer = this.$store.customerOptions.find(customer => {
					if (customer.value == vm.$store.serviceContract.customer_id)
						return true
				})

				if (selectedCustomer)
					return selectedCustomer.text
				else
					return ""
			}
			return ""
		},
		customerName() {
			try {
				let cust = this.$store.serviceContract.Service[0].Customer

				return cust.name
			}
			catch (e) {
				return ""
			}
		},
		totalCostOfProducts() {
			if (this.$store.serviceContract && "ServiceProduct" in this.$store.serviceContract && this.$store.serviceContract.ServiceProduct)
				return this.$store.serviceContract.ServiceProduct.reduce((acc,item) => acc + (+item.price * +item.qty),0)

			return 0
		}
	},
	methods: {
		fetchContract(contractSlugOrId) {
			//not set, fetch it
			let vm = this

			return new Promise((resolve,reject) => {
				let params = {
					include: [
						{
							model: "Material",
							fields: ["id","slug","description","part_number","per","contract_id","category_id"],
							include: [{model:"MaterialCategory",fields: ["id","slug","name"]}]
						},
						{
							model: "Service",
							fields: ["id","slug","job_num","job_name","status","Customer"],
							include: [{model: "Contact",fields:["name"]}]
						},
						{
							model: "User",
							fields: ["id","slug","first_name","last_name","personnel_role_id","user_id"]
						},
						"ServiceContractTask",
						"Contact",
						"ServiceProduct"
					]
				}

				vm.getJSON("ServiceContract/find/"+contractSlugOrId,params).then(response => {

					vm.$store.serviceContract = response.data

					try {
						vm.$store.projectUnionCollectiveAgreements = JSON.parse(response.data.collective_agreements_json)
					}
					catch (e) {}

					resolve(response)
				})
			})
		},
		fetchContractIfNotSet(contractSlugOrId) {
			let vm = this

			return new Promise((resolve,reject) => {

				if (vm.$store.serviceContract && vm.$store.serviceContract.slug != vm.$route.params.slug) {
					this.fetchContract(contractSlugOrId).then(response => {
						resolve(response)
					})
				}
				else {
					//set
					resolve({data:vm.$store.serviceContract})
				}

			})
			
		}
	}
}